export enum PerguntaRespostaTipo {
    SIM = "sim",
    NAO = "nao",
}

export const RotuloResposta: Record<PerguntaRespostaTipo, string> = {
    [PerguntaRespostaTipo.SIM]: "Sim",
    [PerguntaRespostaTipo.NAO]: "Não",
}

export const IconeResposta: Record<PerguntaRespostaTipo, string> = {
    [PerguntaRespostaTipo.SIM]: "pi pi-thumbs-up",
    [PerguntaRespostaTipo.NAO]: "pi pi-thumbs-down",
}

export const CorResposta: Record<PerguntaRespostaTipo, string> = {
    [PerguntaRespostaTipo.SIM]: "--green-500",
    [PerguntaRespostaTipo.NAO]: "--orange-500",
}
